import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
// Local Deps
import './NFButton.scss';

class NFButton extends React.PureComponent {
  render() {
    const { className, children, ...rest } = this.props;
    return (
      <Button className={`nf-button ${className}`} {...rest}>
        {children}
      </Button>
    );
  }
}

NFButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  active: PropTypes.bool,
};

NFButton.defaultProps = {
  className: '',
  children: '',
  active: false,
};

export default NFButton;



// WEBPACK FOOTER //
// ./src/components/primitives/NFButton/NFButton.jsx